import React, { useEffect, useState } from "react";

import Select from "react-select";

import ReactDatetime from "react-datetime";

import jsPDF from "jspdf";
import moment from "moment";
import NotificationAlert from "react-notification-alert";

import ResponsivePagination from "react-responsive-pagination";
import "react-responsive-pagination/themes/classic.css";
// reactstrap components
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Table,
  UncontrolledTooltip,
  Modal,
  ModalBody
} from "reactstrap";

// import Table from '@mui/material/Table';
import TableContainer from "@mui/material/TableContainer";

import Paper from "@mui/material/Paper";

import { withRouter } from "react-router-dom";

import axios from "axios";
import {
  CHANNEL_CLIENT_CHNLTYPE,
  CHAT_HISTORY,
  COMPLETE_CHAT_HISTORY,
  WHATSAPP_ALL_TEMPLATES,
  WHATSAPP_USER_RESPONSE
} from "../../constants.js";
import apiService from "../../variables/apiService.js";

import * as FileSaver from "file-saver";
import autoTable from "jspdf-autotable";
import LoadingScreen from "react-loading-screen";
import * as XLSX from "xlsx";
//import logo from "../../../assets/img/logo.png";
import logo from "../../assets/img/logo.png";
import { ModalFooter } from "react-bootstrap";

let templates = [];
let senderids = [];
const localJson = localStorage.getItem("user");
const user= JSON.parse(localJson)
const Whatsappchatlist = (props) => {
  const [singleSelect, setsingleSelect] = useState( { value: 0, label: "Select All" });
 
  const [chatlist, setChatList] = useState([]);
  const [daywiseListCln, setDaywiseListCln] = useState([]);
  const [drpdwn,setDrpdwn] = useState([{ value: 0, label: "Select Template" }]);
  const [whatsappdetailLst, setWhatsappdetailLst] = useState(null);
  const [whatsappdetailLstC, setWhatsappdetailLstC] = useState(null);

  const [isLoading, setIsLoading] = React.useState(false);
  const [errorhandle,setErrorHandle]= useState()
  const notificationAlertRef = React.useRef(null);
  const [countModal,setCountModal] = useState(false)

  const [chatModal, setChatModal] = useState(false);
  const [chatHistory, setChatHistory] = useState([]);
  const [selectedMobile, setSelectedMobile] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const drpdwns=[
    { value: 0, label: "Select All" },                   
    { value: 1, label: "Utility" },
    { value: 2, label: "Template" },
   
  ]

  const [search, setSearch] = useState({
    fromdate: "",
    todate: "",
    templateid:"",
    campaignname:"",
    senderid:""
  });
  const [validate, setValidate] = useState({
    message: "",
    notValid: false,
  });

  const [channel, setChannel] = useState([]);
  const [dstatus,setStatus] = useState("")
  const [detaileddate,setdetaileddate] = useState("")

  

  const [currentPage, setCurrentPage] = useState(1);
 

  const filteruser = (val) => {
    const filterobj = daywiseListCln?.message?.filter((item) =>
      item.Date.includes(val.toLowerCase())
    );
    setChatList({
      message: filterobj,
    });
  };

  const viewChatHistory = async (date, mobileno,senderid,token,channel) => {
  try {
    setIsLoading(true);

    const fromdate = moment(date).format("YYYY-MM-DD");
    const todate = moment(date).format("YYYY-MM-DD");

    const lclstrg = localStorage.getItem("user");
    const user = JSON.parse(lclstrg);

    const payload = {
      fromdate,
      todate,
      senderid: senderid || search?.senderid?.value || user.sender_id,
      msisdn: mobileno,
      token,
      channel,
      client_id: user.client
    };

    const res = await apiService.postData(
      COMPLETE_CHAT_HISTORY,
      payload
    );

    setChatHistory(res?.data?.message || []);
    setSelectedMobile(mobileno);
    setSelectedDate(fromdate);
    setChatModal(true);
    setIsLoading(false);
  } catch (err) {
    setIsLoading(false);

    let options = {
      place: "tr",
      message: err?.message,
      type: "warning",
      autoDismiss: 3,
    };

    notificationAlertRef?.current?.notificationAlert(options);
  }
};

  const fetchChanelsbyClient=()=>{
    
    setIsLoading(true)

    const payload={
      channels_type:"whatsapp",
      clintId:user?.client
    }  
    
     axios.post(CHANNEL_CLIENT_CHNLTYPE,payload).then(res=>{
    
      templates=[]
     
      setChannel( res?.data)
    

      res?.data?.map((wtsap,i)=>{
        wtsap?.template&&templates.push({ value:wtsap?.template, label: wtsap?.template },)
        
      })
      
      setIsLoading(false)
     }).catch(e=>{
      setIsLoading(false)
      let options = {};
          options = {
            place: "tr",
            message: "Templates Not Found",
            type: "warning",
            autoDismiss: 2,
          };
          notificationAlertRef?.current?.notificationAlert(options);
    })

  }

  const changeSender=(data)=>{
    senderids=[]
    const chnl=channel.filter(item=>item.template==data.value)
      
    const senderid = chnl[0]?.senderid?.split(",");
        for(let i=0;i<senderid?.length;i++){
          senderids.push({label:senderid[i],value:senderid[i]})
        }
 

    setSearch(prev=>({...prev,templateid:data,senderid:""}))
  }
  const submitHandler = async () => {
   

    const isValid=validatedate();
    setErrorHandle(isValid)
    if(Object.keys(isValid).length==0){
    let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(search.todate).format("YYYY-MM-DD");
   

    let lclstrg = localStorage.getItem("user");
    let user = JSON.parse(lclstrg);
    var payload={
        fromdate:fromdate,
        todate:todate,
        senderid:user.sender_id,
      }
    
  
    setIsLoading(true)
    await apiService
      .postData(
        CHAT_HISTORY ,payload
       
      )
      .then((res) => {
        setChatList(res.data);
        setDaywiseListCln(res.data);
        setIsLoading(false)
      })
      .catch((err) =>{
        let options = {};
        options = {
          place: "tr",
          message: err?.message,
          type: "warning",
          autoDismiss: 3,
        };
        setChatList([]);
        notificationAlertRef?.current?.notificationAlert(options);
        setIsLoading(false);
        console.log("error====>", err.message)
      })
    }
  };
  const validatedate=()=>{
    let errors={}
    if(!search.fromdate){
      errors.fromdate="Please Select From Date"
    }  if(!search?.todate){
      errors.todate="Please Select To Date"
    }
    if( singleSelect?.value==2){
       if(!search?.templateid?.value){
      errors.templateid="Please Select Template"
    }
    if(!search?.senderid?.value){
      errors.senderid="Please Select Sender Id"
    }
    }
   
    return errors;
   }
  const generateEXCEL = async (date,type, mobileno,token,channel) => {
   setIsLoading(true)
   let fromdate = moment(date).format("YYYY-MM-DD");
   let todate = moment(date).format("YYYY-MM-DD");
  

   let lclstrg = localStorage.getItem("user");
   let user = JSON.parse(lclstrg);
   let payload={
     fromdate:fromdate,
     todate: todate ,
     senderid:search?.senderid?.value||user.sender_id,
     template:search?.templateid?.value,
     msisdn:mobileno,
     token,
     channel,
     type:singleSelect.value,
     client_id:user.client,
     
   }
      await apiService
      .postData(
        COMPLETE_CHAT_HISTORY ,payload
       
      )
        .then((res) => {
          setIsLoading(false)
          const body =
            res.data.message.length > 0 ? res.data.message : "No Records";
          if (type === 1) {
            const fileType =
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

            const fileExtension = ".xlsx";
            const ws = XLSX?.utils?.json_to_sheet(body);
            const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
            const excelBuffer = XLSX.write(wb, {
              bookType: "xlsx",
              type: "array",
            });
            const data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data, "Chat History Report "+todate + fileExtension);
          } else {
            var rows = [];

            for (let i = 0; i < body.length; i++) {
              var temp = [
                i + 1,
                body[i].Date,
                body[i].TotalRequestssent,
                body[i].TotalDelivered,
                body[i].TotalRead,
                0,
                body[i].TotalTextMessageSent,
                body[i].TotalTextTelivered,
                body[i].TotalTextread,
              ];
              rows.push(temp);
            }

            const doc = new jsPDF("p", "pt");

            autoTable(doc, { html: "#my-table" });
            doc.text(115, 40, `${fromdate} __ ${todate} Daywise Report`);
            autoTable(doc, {
              head: [
                [
                  "S NO",
                  "DATE",
                  "CHANNEL",
                  "SENDERID",
                  "MOBILENO",
                  "USER MESSAGES",
                  "BOT MESSAGES",
                ],
              ],
              body: rows,
            });

            doc.save(todate + ".pdf");
          }
        })
        .catch((err) =>{
          let options = {};
          options = {
            place: "tr",
            message: err?.message,
            type: "warning",
            autoDismiss: 3,
          };
          notificationAlertRef?.current?.notificationAlert(options);
          setIsLoading(false);
          console.log("error====>", err.message)
        })
    
  };


  const generateEXCELMonthly = async () => {
   setIsLoading(true)

  
   let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(search.todate).format("YYYY-MM-DD");
   

    let lclstrg = localStorage.getItem("user");
    let user = JSON.parse(lclstrg);
    let payload={
      fromdate:fromdate,
      todate: todate ,
      senderid:search?.senderid?.value||user?.sender_id,
      template:search?.templateid?.value,
      type:singleSelect.value,
      client_id:user.client,
    }
     
       await apiService
       .postData(
        CHAT_HISTORY ,payload
        
       )
         .then((res) => {
          setIsLoading(false)
           const body =
             res.data.message.length > 0 ? res.data.message : "No Records";
            if(res.data.message.length > 0 ){

             const fileType =
               "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
 
             const fileExtension = ".xlsx";
             const ws = XLSX.utils.json_to_sheet(body);
             const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
             const excelBuffer = XLSX.write(wb, {
               bookType: "xlsx",
               type: "array",
             });
             const data = new Blob([excelBuffer], { type: fileType });
             FileSaver.saveAs(data, "Count Report "+todate + fileExtension);
         
            }
         })
         .catch((err) =>{
          let options = {};
          options = {
            place: "tr",
            message: err?.message,
            type: "warning",
            autoDismiss: 3,
          };
          notificationAlertRef?.current?.notificationAlert(options);
          setIsLoading(false);
          console.log("error====>", err.message)
        })
     
   };

   

  const toDatevalidation = (todt) => {
    setSearch({ ...search, todate: todt });
    let fromdate = moment(search.fromdate).format("YYYY-MM-DD");
    let todate = moment(todt).format("YYYY-MM-DD");

    if (todate >= fromdate) {
      setValidate({
        message: "",
        notValid: false,
      });
    } else {
      setValidate({
        message: "To date should be greater than or equal to from date",
        notValid: true,
      });
    }
  };

  const changeSelect=(data)=>{
   
    setsingleSelect(data)
    if(data.value==1){
      setSearch({...search,template:""})
    }else  if(data.value==2){
      fetchChanelsbyClient();
    }
  }
  var valid = function( current ){
    var yesterday = moment().subtract( 0, 'day' );
  
        return current.isBefore( yesterday );
    };

  const detailedreport=(page,status,date)=>{
      const lclStrge = localStorage.getItem("user");
      const user = JSON.parse(lclStrge);
      let fromdate = date;
      let todate =date;
      const sender_id = user?.sender_id;
      const type = "Outbound";
      const advfltkey = "status";
      const advfltrval = status;
      setIsLoading(true)
      setCurrentPage(page);

      apiService
      // .get(WHATSAPP_USER_RESPONSE + `?fromdate=${fromdate}&todate=${todate}&campaign=${search?.campaignname}&template=${search?.templateid?.value}&mobile=${search.mobile}&senderid=${search?.senderid?.value}&page=` + page)
      .getData(
        WHATSAPP_USER_RESPONSE +
          `?fromdate=${fromdate}&todate=${todate}&senderid=${sender_id}&page=${page}&type=${type}&advfltkey=${advfltkey}&advfltval=${advfltrval}`
      )

      .then((res) => {
        setWhatsappdetailLst(res?.data);
        setWhatsappdetailLstC(res?.data);
        setCountModal(true)
        setIsLoading(false);
       
      })
      .catch((err) => {
        console.log("error===>", err);
        setCurrentPage(1)
        setIsLoading(false);
      });

  }
  return (
    <>
      <div className="content pb-0" >
        <Row>
          <Col md="12">
          
            <Card className="mb-2">
              <CardBody>
             
              <NotificationAlert ref={notificationAlertRef} />
                <Row>
                  <Col md="2" sm="12">
                    <p className="category">From Date</p>
                    <ReactDatetime
                      inputProps={{
                        className: "form-control",
                        placeholder: "Date",
                      }}
                      closeOnSelect={true}
                      timeFormat={false}
                      value={search.fromdate}
                      onChange={(val) => {
                        setSearch({ ...search, fromdate: val._d });
                        setCurrentPage(1)
                      }}
                      isValidDate={ valid }
                    />
                    <span style={{color:"red"}}>{errorhandle?.fromdate}</span>
                  </Col>
                  <Col md="2" sm="12">
                    <p className="category">To Date</p>
                    <ReactDatetime
                      inputProps={{
                        className: "form-control",
                        placeholder: "Date",
                      }}
                      closeOnSelect={true}
                      timeFormat={false}
                      value={search.todate}
                      onChange={(val) => {
                        toDatevalidation(val._d);
                        setCurrentPage(1)
                      }}
                      isValidDate={ valid }
                      // onChange={(val) =>{setSearch({...search,todate:val._d});setValidate({
                      //   message:"",
                      //   notValid:false
                      // } )}}
                    />
                   <span style={{color:"red"}}>{errorhandle?.todate}</span>
                  </Col>

                  

                  <Col md="2" sm="12">
                    <Button
                      color="primary "
                      className="mt-4 btn btn-icon animation-on-hover"
                      id="tooltipsubmit"
                      type="button"
                      onClick={() => submitHandler()}
                    >
                      <i className="tim-icons icon-double-right" />
                    </Button>
                   
                    
                   
                   
                  </Col>

                 
              
                </Row>
                <Row>
                  
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col className="mb-0" md="12">
            <Card className="mb-0">
              <CardBody className="mb-0">
              <LoadingScreen
          children=""
          loading={isLoading}
          bgColor="rgba(0,0,0,0.7)"
          spinnerColor="#9ee5f8"
          textColor="#676767"
          logoSrc={logo}
          text="Loading..."
        ></LoadingScreen>
                <TableContainer component={Paper}  className="tableheight">
                  <Table
                    sx={{ minWidth: 650 }}
                    aria-label="simple table"
                    responsive
                    striped
                  >
                    <thead>
                      <tr>
                        <th rowspan="2">S no </th>
                        <th rowspan="2"> Date</th>
                        <th>Token </th>
                        <th>Channel</th>
                        <th>Mobile Number </th>
                        
                        <th>Action </th>
                      
                      </tr>
                     
                    </thead>
                    <tbody>
                 
                      {chatlist?.message?.length > 0 ? (
                        chatlist?.message?.map((row, index) => (
                          
                          <tr
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <td>{index + 1}</td>
                            <td> {moment(row.sdate).format("YYYY-MM-DD")}</td>
                            <td>{row.token}  </td>
                            <td>{row.channel}  </td>
                            <td>{row.mobileno}  </td>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
                            <td>
                              <span
                                style={{ cursor: "pointer", marginRight: "15px" }}
                                onClick={() => generateEXCEL(row.sdate, 1, row.mobileno,row.token,row.channel)}
                              >
                                <i className="tim-icons icon-cloud-download-93" />
                              </span>

                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => viewChatHistory(row.sdate, row.mobileno,row.senderid,row.token,row.channel)}
                              >
                                <i className="tim-icons icon-chat-33" />
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <td colSpan={9}>No Records</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </TableContainer>
              </CardBody>
              {/* <Row>
              <Col md="12" >
          <Pagination  className='pull-right'>
                    <PaginationItem>
                      <PaginationLink
                        aria-label="Previous"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        <span aria-hidden={true}>
                          <i
                            aria-hidden={true}
                            className="tim-icons icon-double-left"
                          />
                        </span>
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        1
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem className="active">
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        2
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        3
                      </PaginationLink>
                    </PaginationItem>
                    <PaginationItem>
                      <PaginationLink
                        aria-label="Next"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                      >
                        <span aria-hidden={true}>
                          <i
                            aria-hidden={true}
                            className="tim-icons icon-double-right"
                          />
                        </span>
                      </PaginationLink>
                    </PaginationItem>
                  </Pagination>
          </Col>
              </Row> */}
            </Card>
          </Col>
        </Row>
      </div>

<Modal
  isOpen={chatModal}
  toggle={() => setChatModal(false)}
  size="lg"
>
  <ModalBody>
    <h4>
      Chat History
    </h4>

    <div>
      <strong>Date:</strong> {selectedDate}
    </div>

    <hr />
<Row
  style={{
    marginBottom: "10px",
    fontWeight: "bold",
    borderBottom: "2px solid #ddd",
    paddingBottom: "10px",
  }}
>
  <Col md="6" style={{ textAlign: "left" }}>
    User Message
  </Col>
  <Col md="6" style={{ textAlign: "right" }}>
    Bot Message
  </Col>
</Row>
    <div
  style={{
    maxHeight: "500px",
    overflowY: "auto",
    padding: "15px",
    backgroundColor: "#f5f5f5",
  }}
>
  {chatHistory.length > 0 ? (
    chatHistory.map((chat, index) => (
      <div key={index}>
        {/* User Message - Left */}
        {chat.user_msg && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              marginBottom: "8px",
            }}
          >
            <div
              style={{
                maxWidth: "70%",
                padding: "10px 15px",
                borderRadius: "10px",
                backgroundColor: "#ffffff",
                border: "1px solid #ddd",
                wordBreak: "break-word",
              }}
            >
              {chat.user_msg}
            </div>
          </div>
        )}

        {/* Bot Message - Right */}
        {chat.bot_msg && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "15px",
            }}
          >
            <div
              style={{
                maxWidth: "70%",
                padding: "10px 15px",
                borderRadius: "10px",
                backgroundColor: "#DCF8C6",
                border: "1px solid #ddd",
                wordBreak: "break-word",
              }}
            >
              {chat.bot_msg}
            </div>
          </div>
        )}
      </div>
    ))
  ) : (
    <div>No Chat History Found</div>
  )}
</div>
  </ModalBody>

  <ModalFooter>
    <Button
      color="secondary"
      onClick={() => setChatModal(false)}
    >
      Close
    </Button>
  </ModalFooter>
</Modal>

    </>
  );
};

export default withRouter(Whatsappchatlist);
